/**
  Initializes a dropdown component
  @param {HTMLElement} el - The HTML element on which to initialize the dropdown.
*/

export class Dropdown {
  constructor(el) {
    this.container = el;
    this.containerHeight = el.offsetHeight;
    this.trigger = el.querySelector("drop-down-trigger");
    this.dropdown = el.querySelector("drop-down");
    this.iconOpen = this.trigger.querySelector("icon-open");
    this.iconClosed = this.trigger.querySelector("icon-closed");

    this.openHeight = this.containerHeight + this.dropdown.offsetHeight;
    this.isOpen = false;

    this.toggle = () => {
      this.iconClosed.style.visibility = this.isOpen ? "visible" : "hidden";
      this.iconOpen.style.visibility = this.isOpen ? "hidden" : "visible";
      this.trigger.ariaExpanded = this.isOpen ? "false" : "true";
      this.trigger.ariaLabel = this.isOpen ? "Open" : "Close";

      this.container.style.height = this.isOpen
        ? `${this.trigger.offsetHeight}px`
        : `${this.openHeight}px`;
      this.isOpen = !this.isOpen;
    };

    this._init();
  }

  _init = () => {
    // Add an event listener to the trigger element to toggle the dropdown
    this.trigger.addEventListener("click", () => {
      this.toggle();
    });

    this.trigger.addEventListener("keypress", (e) => {
      if (e.code === "Enter") this.toggle();
    });

    // Add a resize event listener to recalculate container and open heights
    window.addEventListener("resize", () => {
      this.openHeight = this.containerHeight + this.dropdown.offsetHeight;
    });

    return () => {
      this.container.removeEventListener("click", this.container._init);
      this.container.removeEventListener("keypress", this.container._init);
      this.container.removeEventListener("resize", this.container._init);
    };
  };
}
